import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SqlDatasetSchema = withDefaults({
  type: 'sql-dataset',
  fields: [
    {
      kind: 'attribute',
      name: 'slug',
    },
    {
      kind: 'attribute',
      name: 'label',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'product',
    },
    {
      kind: 'attribute',
      name: 'baseQuery',
    },
    {
      kind: 'attribute',
      name: 'fieldCatalog',
    },
    {
      kind: 'attribute',
      name: 'tenantBinding',
    },
    {
      kind: 'attribute',
      name: 'allowedRoles',
    },
    {
      kind: 'attribute',
      name: 'guardrails',
    },
    {
      kind: 'attribute',
      name: 'explainSnapshot',
    },
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'uniqueKeyColumn',
    },
    {
      kind: 'attribute',
      name: 'crossCompanyCapable',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default SqlDatasetSchema;
